import { FunctionComponent } from 'react';
import { createFragmentContainer, graphql, Environment } from 'react-relay';
import { connect } from 'react-redux';
import SiteNav from '../SiteNav/SiteNav';
import Contact1stdibsLink from '../Contact1stdibsLink/Contact1stdibsLink';

import styles from './BottomBar-style.scss';

import { BottomBar_viewer as ViewerType } from './__generated__/BottomBar_viewer.graphql';

type ReduxStoreType = {
    header: {
        isUserTypeTrade: boolean;
    };
};

type BottomBarProps = {
    hasUserId: boolean;
    hasRootPendingRefetch: boolean;
    isUserTypeTrade: boolean;
    viewer: ViewerType;
    userId: string;
    environment: Environment;
};

const BottomBar: FunctionComponent<BottomBarProps> = ({
    hasUserId,
    hasRootPendingRefetch,
    isUserTypeTrade,
    viewer,
}) => {
    return (
        <div className={styles.bar}>
            <div className={styles.barContent}>
                <div className={styles.wrapper} data-tn="main-nav-bottom">
                    <SiteNav viewer={viewer} />
                    <Contact1stdibsLink
                        hasUserId={hasUserId}
                        hasRootPendingRefetch={hasRootPendingRefetch}
                        isUserTypeTrade={isUserTypeTrade}
                        viewer={viewer}
                    />
                </div>
            </div>
        </div>
    );
};

const mapStateToProps = ({
    header,
}: ReduxStoreType): {
    isUserTypeTrade: boolean;
} => {
    const { isUserTypeTrade } = header;
    return {
        isUserTypeTrade,
    };
};

export default createFragmentContainer(connect(mapStateToProps)(BottomBar), {
    viewer: graphql`
        fragment BottomBar_viewer on Viewer {
            ...SiteNav_viewer
            ...Contact1stdibsLink_viewer
        }
    `,
});
